import { Typography } from "@mui/material";
import React from "react";
import hexToRGB from "utils/hexToRGB";

interface IAcxProgress {
    //used for label and rendering background width
    percentComplete: string;
    //change the color of the progress bar
    backgroundColor: string;
    bottomLabel?: string | undefined;
}

const AcxProgress = (props: IAcxProgress) => {
    return (
        <div style={{ width: "100%" }}>
            <div
                style={{
                    height: "6px",
                    width: "100%",
                    backgroundColor: "#e0e0de",
                    borderRadius: "2px",
                    margin: "1px",
                }}
            >
                <div
                    style={{
                        width: `${props.percentComplete}%`,
                        backgroundColor: props.backgroundColor,
                        height: "100%",
                        transition: "width 1s ease-in-out",
                        borderRadius: "inherit",
                        textAlign: "right",
                    }}
                ></div>
            </div>
            {props.bottomLabel && (
                <Typography
                    component="div"
                    variant="caption"
                    style={{ color: hexToRGB(props.backgroundColor, 0.6) }}
                >
                    {props.bottomLabel}
                </Typography>
            )}
        </div>
    );
};

export default AcxProgress;
